import React__default from 'react';
import PropTypes from 'prop-types';

var propTypes = {
  /** The steps to display inside the progress steps container. Typically a set of `ProgressStep` components */
  children: PropTypes.node.isRequired
};
function ProgressSteps(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "progress-steps",
    "data-testid": "progress-steps-wrapper"
  }, children);
}
ProgressSteps.propTypes = propTypes;

export { ProgressSteps as default };
//# sourceMappingURL=ProgressSteps.js.map
